import { supportsDataView as e } from "./_setup.js";
import a from "./_hasObjectTag.js";
var r = e && a(new DataView(new ArrayBuffer(8))),
  t = "undefined" != typeof Map && a(new Map());
export { r as hasStringTagBug, t as isIE11 };